<style scoped>
/* Style the input fields */
select,
input {
  padding: 8px;
  width: 100%;
  font-size: 17px;
  font-family: Raleway;
  border-radius: 5px;
  border: 0.5px solid silver;
  border-right: none !important;
  border-top-right-radius: 0px !important;
  /* background-color: white; */
  border-bottom-right-radius: 0px !important;
}

.select {
  height: 45px;
}

.form_color {
  height: 40px;
  max-width: 100px;
  border: 1px solid gray !important;
}

.radio #radio-group-1,
.checkbox #checkbox-group-1 {
  display: inline-block;
}

.radio .radio-tooltip {
  border: 0.5px solid silver;
  border-left: none;
  border-radius: 5px;
  justify-content: center;
  border-radius: 50% !important;
  width: 25px !important;
  height: 25px !important;
  font-size: 12px !important;
}

.tooltip-button {
  position: relative !important;
  border: 0.5px solid silver;
  border-left: none;
  border-radius: 5px;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  background-color: #f8f9fa;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #6c757d;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.tooltip-button:hover {
  background-color: #e9ecef;
  color: #495057;
  border-color: #adb5bd;
}

.tooltip-button:active {
  background-color: #dee2e6;
}

.tooltip-button i {
  font-size: 14px;
}

/* Custom tooltip styling */
.custom-tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 14px;
  white-space: normal;
  max-width: 250px;
  min-width: 150px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  line-height: 1.4;
}

.custom-tooltip.show {
  opacity: 1;
  visibility: visible;
  animation: tooltipFadeIn 0.3s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.custom-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

/* Tooltip on right side for edge cases */
.tooltip-button:last-child .custom-tooltip,
.radio-button.tooltip-button .custom-tooltip {
  left: auto;
  right: 0;
  transform: translateX(0);
}

.tooltip-button:last-child .custom-tooltip::after,
.radio-button.tooltip-button .custom-tooltip::after {
  left: auto;
  right: 15px;
  transform: translateX(0);
}

/* For radio button tooltip */
.radio-button.tooltip-button {
  margin-left: 10px;
  display: inline-flex;
}

.input,
.file,
.select,
.textarea {
  display: flex;
}

textarea,
select {
  outline: 0;
  font-size: 17px;
  font-family: Raleway;
  border-radius: 5px;
  border: 0.5px solid silver !important;
  border-right: none;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

textarea:focus {
  outline: auto;
  border: 1px solid black;
}

.textarea_height{
  height: 200px;
}

/* Mark input boxes that gets an error on validation: */
.invalid {
  background-color: #ffdddd;
}

/* Hide all steps by default: */
.tab,
.title {
  display: none;
}

.tab.visible{
  display: block;
}

/* Make circles that indicate the steps of the form: */
.step {
  height: 10px;
  width: 30px;
  margin: 0 4px;
  border: none;
  /* border-radius: 50%; */
  display: inline-block;
  opacity: 0.5;
  background-color: rgb(5, 40, 85);
}

label {
  text-transform: capitalize;
}

/* Mark the active step: */
.step.active {
  opacity: 1;
}

/* Mark the steps that are finished and valid: */
.step.finish {
  opacity: 1;
  background-color: #28a745;
}
</style>
<template>
  <div v-if="pages.length > 0" 
    :style="{ 
        '--customization_custom_background': customization.custom_background , 
        '--customization_custom_color': customization.custom_color,
        '--customization_font_family': customization.font_family,
        '--customization_label_font_family': customization.label_font_family,
        '--customization_label_color': customization.label_color,
        '--customization_button_border_color': customization.button_border_color,
        '--customization_button_border': customization.button_border,
      }"
    class="container mt-5 p-3 card shadow-md shadow-lg"
    >
    <app-overlay-loader v-if="preloader" />
    <div class="card-header">
      <h4 class="font-weight-bold" style="color: rgb(5, 40, 85)">
        {{ formname }}
      </h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6" style="background-color: rgba(5, 40, 85, 0.05)">
          <form action="">
            <!-- Circles which indicates the steps of the form: -->
            <div class="row d-flex justify-content-center mt-3" style="text-align: center">
              <span class="step text-white d-flex" :class="{ active: currentTab === index, finish: index < currentTab }" v-for="(page, index) in pages" :key="index" @click="goToTab(index)" style="cursor: pointer;"></span>
            </div>
            <!-- One "tab" for each step in the form: -->
            <div :class="['tab mt-4', { 'visible': currentTab === index }]" v-for="(page, index) in pages" :key="page.id">
              <h5 class="mt-4 mb-4 text-capitalize">{{ replaceFieldKeysWithValues(page.name) }}</h5>
              <div class="mb-5" v-html="replaceFieldKeysWithValues(page.step_description)"></div>
              <div class="row">
                <div v-if="page.custom_values.length<=0" class="w-100 text-center mt-4 pt-4 mb-4 pb-4">
                  <h3 class="text-center text-warning mt-4 pt-4 mb-4 pb-4">
                    {{ emptyStateConfig.message }}
                  </h3>
                  <div v-if="emptyStateConfig.purchase_url" class="mt-2">
                    <a :href="emptyStateConfig.purchase_url" target="_blank" rel="noopener" class="btn" :style="{ backgroundColor: customization.button_background, color: customization.button_color, borderColor: customization.button_border_color, borderWidth: customization.button_border + 'px' }">
                      {{ emptyStateConfig.link_text }}
                    </a>
                  </div>
                </div>
                <div v-else class="col-lg-12" v-for="(custom_value, val_index) in Object.values(page.custom_values)"
                  :key="custom_value.db_id">
                  <!--select-->
                  <div v-if="
                    'select' ===
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="" class="d-block">{{
                      custom_value.field_name
                    }}</label>
                    <p class="select">
                      <select class="form-control" :class="{ required: custom_value.required }"
                        oninput='this.classList.remove("invalid")' :name="custom_value.field_name"
                        :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="
                          setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                        ">
                        <option disabled :value="''" selected="selected">
                          Please select an option
                        </option>
                        <option v-for="element in custom_value.choices.split(';')" :key="element" :value="element">
                          {{ element }}
                        </option>
                      </select> 

                      <button type="button" class="tooltip-button shadow-sm" 
                        @mouseenter="showTooltip($event, custom_value.field_key)"
                        @mouseleave="hideTooltip()"
                        @click="toggleTooltip($event, custom_value.field_key)">
                        <i class="fas fa-info-circle"></i>
                        <div v-show="isTooltipActive(custom_value.field_key)" class="custom-tooltip show">
                          <p v-html="custom_value.description || 'No description available' "></p>
                        </div>
                      </button>
                    </p>
                  </div>

                  <!--multi-select-->
                  <div v-if="
                    'multi-select' ===
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="" class="d-block">{{
                      custom_value.field_name
                    }}</label>

                    <p class="select">
                      <multiselect :name="custom_value.field_name" :ref="custom_value.field_name" :multiple="true"
                        :clear-on-select="false" :preserve-search="true" placeholder="Please select option"
                        v-model="field_values[index][val_index].value" @input="
                          setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                        " :preselect-first="false" :close-on-select="false" :options="custom_value.choices.split(';')">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span
                            class="multiselect__single" v-if="values.length > 0 && !isOpen">{{ values.length }} options
                            selected</span></template>
                      </multiselect>

                      <button type="button" class="tooltip-button shadow-sm" 
                        @mouseenter="showTooltip($event, custom_value.field_key)"
                        @mouseleave="hideTooltip()"
                        @click="toggleTooltip($event, custom_value.field_key)">
                        <i class="fas fa-info-circle"></i>
                        <div v-show="isTooltipActive(custom_value.field_key)" class="custom-tooltip show">
                          <p v-html="custom_value.description || 'No description available' "></p>
                        </div>
                      </button>
                    </p>
                  </div>

                  <!--text-->
                  <div v-if="
                    ['text', 'number', 'password', 'date'].includes(
                      custom_value_type(custom_value.custom_field_type_id)
                    )
                  " class="mb-2">
                    <label for="">{{ custom_value.field_name }}</label>
                    <p class="input">
                      <span class="input-group-prepend" v-if="custom_value.prefix">
                        <span class="input-group-text" style="height: 47.5px;">{{ custom_value.prefix }}</span>
                      </span>
                      
                      <input class="shadow-sm " :class="{ required: custom_value.required }"
                        v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)"
                        :type="custom_value_type(custom_value.custom_field_type_id)" :placeholder="custom_value.field_name"
                        :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name" @change="setCustomValue(
                          getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          ),
                          custom_value
                        )
                        " :value="getFieldOperationValue(
          operations_values[custom_value.field_key].operand1,
          operations_values[custom_value.field_key].operand2,
          operations_values[custom_value.field_key].operator,
          operations_values[custom_value.field_key].type
        )
        " oninput='this.classList.remove("invalid")' />

                      <input class="shadow-sm form-control" :class="{ required: custom_value.required }" v-else
                        :type="custom_value_type(custom_value.custom_field_type_id)" :placeholder="custom_value.field_name"
                        :ref="custom_value.field_name" :name="custom_value.field_name"
                        v-model="field_values[index][val_index].value" @input="setCustomValue(
                          field_values[index][val_index].value,
                          custom_value
                        )
                        " oninput='this.classList.remove("invalid")' />
                      <span class="input-group-append" v-if="custom_value.suffix">
                        <span class="input-group-text">{{ custom_value.suffix }}</span>
                      </span>

                      <button type="button" class="tooltip-button shadow-sm" 
                        @mouseenter="showTooltip($event, custom_value.field_key)"
                        @mouseleave="hideTooltip()"
                        @click="toggleTooltip($event, custom_value.field_key)">
                        <i class="fas fa-info-circle"></i>
                        <div v-show="isTooltipActive(custom_value.field_key)" class="custom-tooltip show">
                          <p v-html="custom_value.description || 'No description available' "></p>
                        </div>
                      </button>
                    </p>
                  </div>

                  <!--textarea-->
                  <div v-if="
                    'textarea' ==
                    custom_value_type(custom_value.custom_field_type_id)
                  " class="mb-2">
                    <label for="" class="d-block">{{custom_value.field_name}}</label>
                    <p class="textarea">
                        <app-input 
                        v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                            custom-config
                            type="textarea"
                            class="shadow-sm w-100 " 
                            :removeClass="true"
                            inputClass="textarea_height"
                            :required="true"
                            :id="'textarea-id' + index + val_index"
                            :label="custom_value.field_name"
                            :class="{ required: custom_value.required }"
                            :name="custom_value.field_name" 
                            :ref="custom_value.field_name"
                            
                            @input="setCustomValue(
                              getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              ),
                              custom_value
                            )
                            " :value="getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              )"
                            oninput='this.classList.remove("invalid")'
                            :placeholder="custom_value.field_name" 
                          />

                      
                            <app-input v-else
                            custom-config
                            type="textarea"
                            class="shadow-sm w-100 " 
                            :removeClass="true"
                            inputClass="textarea_height"
                            :required="true"
                            :id="'textarea-id' + index + val_index"
                            :key="'text-editor-id' + index + val_index"
                            :label="custom_value.field_name"
                            :class="{ required: custom_value.required }"
                            :name="custom_value.field_name" 
                            :ref="custom_value.field_name"
                            v-model="field_values[index][val_index].value"
                            @input="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )
                            " 
                            oninput='this.classList.remove("invalid")'
                            :placeholder="custom_value.field_name" 
                          />

                      <button type="button" class="tooltip-button shadow-sm" 
                        @mouseenter="showTooltip($event, custom_value.field_key)"
                        @mouseleave="hideTooltip()"
                        @click="toggleTooltip($event, custom_value.field_key)">
                        <i class="fas fa-info-circle"></i>
                        <div v-show="isTooltipActive(custom_value.field_key)" class="custom-tooltip show">
                          <p v-html="custom_value.description || 'No description available' "></p>
                        </div>
                      </button>
                    </p>
                  </div>


                  <!--color picker-->
                  <div v-if="'Color picker' ===
                      custom_value_type(custom_value.custom_field_type_id)
                      ">
                    <div class="mb-4">
                      <label class="d-block">
                        {{ custom_value.field_name }}
                      </label>
                      <div v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)">
                        <input type="color" class="form_color" disabled :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name"
                        @change="setCustomValue(
                              getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              ),
                              custom_value
                            )
                            " :value="getFieldOperationValue(
              operations_values[custom_value.field_key].operand1,
              operations_values[custom_value.field_key].operand2,
              operations_values[custom_value.field_key].operator,
              operations_values[custom_value.field_key].type
            )" />
                        <input type="text" disabled class="form_color"  :readonly="true" 
                        :ref="custom_value.field_name" :name="custom_value.field_name"
                        @change="setCustomValue(
                              getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              ),
                              custom_value
                            )
                            " :value="getFieldOperationValue(
              operations_values[custom_value.field_key].operand1,
              operations_values[custom_value.field_key].operand2,
              operations_values[custom_value.field_key].operator,
              operations_values[custom_value.field_key].type
            )" 
                        />
                      </div>

                      <div v-else>
                        <input type="color" class="form_color" v-model="field_values[index][val_index].value" @input="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )" />
                        <input type="text" class="form_color" v-model="field_values[index][val_index].value" @input="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )" />
                      </div>
                    </div>
                  </div>

                  <!--file-->
                  <div class="mb-4" v-if="'File' ===
                    custom_value_type(custom_value.custom_field_type_id)
                    ">
                    <File :custom_value="custom_value" />
                  </div>

                  <!--text editor-->
                  <div v-if="'text-editor' ==
                    custom_value_type(custom_value.custom_field_type_id)
                    " class="mb-2">
                    <label for="" class="d-block">{{custom_value.field_name}}</label>
                    <p class="textarea">
                        <app-input 
                        v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                            custom-config
                            type="text-editor"
                            class="shadow-sm w-100 " 
                            :required="true"
                            :id="'text-editor-id' + index + val_index"
                            :label="custom_value.field_name"
                            :class="{ required: custom_value.required }"
                            :name="custom_value.field_name" 
                            :ref="custom_value.field_name"
                            
                            @input="setCustomValue(
                              getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              ),
                              custom_value
                            )
                            " :value="getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              )"
                            oninput='this.classList.remove("invalid")'
                            :placeholder="custom_value.field_name" 
                          />

                      
                            <app-input v-else
                            custom-config
                            type="text-editor"
                            class="shadow-sm w-100 " 
                            :required="true"
                            :id="'text-editor-id' + index + val_index"
                            :key="'text-editor-id' + index + val_index"
                            :label="custom_value.field_name"
                            :class="{ required: custom_value.required }"
                            :name="custom_value.field_name" 
                            :ref="custom_value.field_name"
                            v-model="field_values[index][val_index].value"
                            @input="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )
                            " 
                            oninput='this.classList.remove("invalid")'
                            :placeholder="custom_value.field_name" 
                          />

                      <button type="button" class="tooltip-button shadow-sm" 
                        @mouseenter="showTooltip($event, custom_value.field_key)"
                        @mouseleave="hideTooltip()"
                        @click="toggleTooltip($event, custom_value.field_key)">
                        <i class="fas fa-info-circle"></i>
                        <div v-show="isTooltipActive(custom_value.field_key)" class="custom-tooltip show">
                          <p v-html="custom_value.description || 'No description available' "></p>
                        </div>
                      </button>
                    </p>
                  </div>

                  <!--radio-->
                  <div v-if="
                    'radio' ===
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="" class="d-block">{{
                      custom_value.field_name
                    }}</label>

                    <p class="radio">

                    <div class="form-check form-check-inline"
                      v-for='(item, item_index) in (custom_value.choices.split(";"))'>
                      <input class="form-check-input" oninput='this.classList.remove("invalid")'
                        :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                        :name="custom_value.field_name" v-model="field_values[index][val_index].value" @change="
                          setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                        " type="radio" :id="'inlineRadio' + item_index" :value="item" />
                      <label class="form-check-label" :for="'inlineRadio' + item_index"> {{ item }}</label>
                    </div>

                    <button type="button" class="radio-button tooltip-button shadow-sm"
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                      <div v-show="isTooltipActive(custom_value.field_key)" class="custom-tooltip show">
                        <p v-html="custom_value.description || 'No description available' "></p>
                      </div>
                    </button>
                    </p>
                  </div>

                  <!--checkbox-->
                  <div v-if="'checkbox' ===
                    custom_value_type(custom_value.custom_field_type_id)
                    ">
                    <label for="" class="d-block">{{custom_value.field_name}}</label>
                    <p class="checkbox">
                    <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#single:')">
                      <input class="form-check-input mt-4" id="checkbox-1" oninput='this.classList.remove("invalid")'
                        :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                        v-model="field_values[index][val_index].value" @change="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )
                            " :value="custom_value.choices
              .replace(/#multiple:|#single:/gi, '')
              .split(';')[0]
            " :unchecked-value="custom_value.choices
              .replace(/#multiple:|#single:/gi, '')
              .split(';')[1]
            " type="checkbox">
                      <label class="form-check-label" for="inlineCheckbox1">{{ custom_value.field_name }}</label>
                    </div>

                    <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#multiple:')"
                      v-for='(item, item_index) in custom_value.choices.replace(/#multiple:|#single:/gi, "").split(";")'>
                      <input class="form-check-input mt-4" :id="item" :class="{ required: custom_value.required }"
                        :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                          " oninput='this.classList.remove("invalid")' type="checkbox" :value="item">
                      <label class="form-check-label" for="'item'">{{ item }}</label>
                    </div>
                    <button type="button" class="tooltip-button shadow-sm" data-toggle="tooltip" data-placement="top"
                      :title="custom_value.description">
                      <i class="fas fa-info"></i>
                    </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row d-flex justify-content-between px-3" style="overflow: auto">
              <div class="">
                <button v-if="currentTab > 0" class="btn btn-outline-secondary" type="button" id="prevBtn" @click="nextPrev(-1)">
                  Previous
                </button>
              </div>
              <div class="d-flex justify-content-end bg-success">
                <button class="btn btn-primary" type="button" id="nextBtn" @click="nextPrev(1)">
                  <span v-if="currentTab < pages.length - 1">Next</span>
                  <span v-else>Save</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="
              col-lg-6
              justify-content-center
              align-items-center
              d-none d-lg-block
            ">
          <div class="d-flex justify-content-center align-items-center" style="height: 100%; position: relative">
            <img :src="urlGenerator('/images/img.jpg')" style="width: 100%; height: 100%; border-radius: 5px" />
            <div style="position: absolute; bottom: 10; padding: 15">
              <p class="text-white" style="font-size: 18px">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Debitis quaerat nam laborum. Ea veniam enim nostrum laborum ab
                vel itaque voluptatem minus voluptas iusto. Laudantium amet rem
                beatae architecto hic.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-4 pt-4">
    <h1 class="text-center mt-4 pt-4">
      You need to add pages and customs values on your application.
    </h1>
    <a :href="urlGenerator('app/custom')" type="button" class="btn btn-primary btn-with-shadow mt-4">
      custom values
    </a>
  </div>
</template>


<script>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Verte from 'verte';
import coreLibrary from "../../../../core/helpers/CoreLibrary";
import 'verte/dist/verte.css';
import Multiselect from "vue-multiselect";
import FirstInput from "./components/FirstInput.vue";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

import File from "./components/file.vue";
export default {
  mixins: [FormMixin],
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "customization",
    "originalCustomValues",
    "formname",
    "emptyStateConfig",
  ],
  components: { Multiselect, verte: Verte, FirstInput, File },

  data() {
    return {
      modalName: "",
      modalDescription: "",
      name: "TextArea",
      next_click: [],
      main_form: [],
      step_list: [],
      num: [],
      formnumber: 0,
      validate_inputs: [],
      validate_textarea: [],
      nb: 5,


      currentTab: 0,

      urlGenerator,
      preloader: false,
      filePreloader: false,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      customValues: [],
      activeTooltipId: null,
      tooltipTimeout: null,

    };
  },


  created() {
    this.reorderPage();
    console.log(this.pages);
    console.log(this.pages);

    this.pages.forEach((page, page_index) => {
      let data = [];
      //page.custom_values.sort(this.compare);
      Object.values(page.custom_values).forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value ?? "") });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {

                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {

                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {

                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });
      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });
  },

  mounted() {
    // Initialize the first tab
    this.$nextTick(() => {
      this.showTab(0);
    });
    
    this.next_click = document.querySelectorAll(".next_button");
    this.main_form = document.querySelectorAll(".main");
    this.step_list = document.querySelectorAll(".progress_bar li");
    this.num = document.querySelector(".step-number");
    this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active textarea")];

    this.next_click.forEach((next_click_form, index) => {
      if (index == 0) {
        next_click_form.addEventListener("click", () => {
          this.save(true);
        });
      } else {
        next_click_form.addEventListener("click", () => {
          this.save(false);
        });
      }
    });
    var back_click = document.querySelectorAll(".back_button");
    back_click.forEach((back_click_form) => {
      back_click_form.addEventListener("click", this.onBack);
    });
    var username = document.querySelector("#user_name");
    var shownname = document.querySelector(".shown_name");
    var submit_click = document.querySelectorAll(".submit_button");
    submit_click.forEach(function (submit_click_form) {
      submit_click_form.addEventListener("click", function () {
        shownname.innerHTML = username.value;
        this.formnumber++;
        this.updateform();
      });
    });
    
    // Add click outside listener for tooltips
    document.addEventListener('click', this.handleClickOutside);
  },
  
  beforeDestroy() {
    // Clean up event listener
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    replaceFieldKeysWithValues(text) {
        if (!text || typeof text !== 'string') return text;
        
        if (this.action == "test") {
          return this.originalCustomValues.reduce((result, field) => {
              const escapedKey = this.escapeRegExp(field.fieldKey);
              return result.replace(new RegExp(escapedKey, 'g'), field.value || '');
          }, text);
        }else{
          return this.originalCustomValues.customValues.reduce((result, field) => {
              const escapedKey = this.escapeRegExp(field.fieldKey);
              return result.replace(new RegExp(escapedKey, 'g'), field.value || '');
          }, text);
        }
    },
    escapeRegExp(string) {
        if (!string) return '';
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    getPrefixValue(prefix){
      if (prefix && prefix.length > 0) {
        return prefix
      } else {
        return ""
      }
    },

    getSuffixValue(suffix){
      if (suffix && suffix.length > 0) {
        return suffix
      } else {
        return ""
      }
    },

    removePrefixSuffixValue(prefix, suffix, value) {
      if (typeof value !== "string") {
        return value
      }
      if (value.startsWith(prefix) && prefix!=null) {
        value = value.substr(prefix.length);
      }

      if (value.endsWith(suffix) && suffix!=null) {
        value = value.substr(0, value.length - suffix.length);
      }
      return value;
    },

    hasOperation(fieldKey, field_key){
      return this.operations_index.includes(fieldKey) || this.operations_index.includes(field_key);
    },

    showToolTip(_child) {
      let explanations = document.querySelectorAll(".SpeechBubble");

      let child = document.querySelector(_child);
      var scaleX = child.getBoundingClientRect().width / child.offsetWidth;
      if (scaleX == 0) {
        explanations.forEach(element => {
          element.style.animationName = "shrink";
          element.style.animationDuration = "0.1s";
        });

        child.style.animationName = "expand-bounce";
        child.style.animationDuration = "0.25s";
      } else {
        child.style.animationName = "shrink";
        child.style.animationDuration = "0.1s";
      }
    },

    hideToolTip(_child) {
      let child = document.querySelector(_child);
      child.style.animationName = "shrink";
      child.style.animationDuration = "0.1s";
    },

    ShowToolTip(name, description) {
      this.modalName = name;
      this.modalDescription = description;
      window.dialog.showModal();
    },

    HideToolTip() {
      this.modalName = "";
      this.modalDescription = "";
      window.dialog.close();
    },

    reorderPage() {
      this.pages.sort((a, b) => {
        if (a.position < b.position) {
          return -1;
        }
        if (a.position > b.position) {
          return 1;
        }

        return 0;
      });
    },

    showTab(index) {
      // Update currentTab to ensure sync
      this.currentTab = index;
      
      // Force Vue to re-render
      this.$forceUpdate();
      
      // Use Vue's nextTick to ensure DOM is updated
      this.$nextTick(() => {
        // Get all tabs
        var tabs = document.getElementsByClassName("tab");
        
        // Hide all tabs
        for (let i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove("visible");
        }
        
        // Show the specific tab
        if (tabs[index]) {
          tabs[index].classList.add("visible");
        }
        
        // Update step indicators
        var steps = document.getElementsByClassName("step");
        for (let i = 0; i < steps.length; i++) {
          steps[i].classList.remove("active", "finish");
          if (i < index) {
            steps[i].classList.add("finish");
          } else if (i === index) {
            steps[i].classList.add("active");
          }
        }
      });
    },

    goToTab(index) {
      // Allow clicking to navigate to any tab
      this.currentTab = index;
      this.showTab(index);
    },

    contentChange(change = false) {
      this.customValues = [];

      Object.values(this.pages[this.formnumber].custom_values).forEach(
        (custom_value, val_index) => {
          const operation = this.operations.find(
            ({ result }) => result === custom_value.fieldKey
          );

          if (operation == null) {
            this.customValues.push({
              id: custom_value.cv_id,
              fieldKey: custom_value.fieldKey,
              field_type: this.custom_value_type(custom_value.custom_field_type_id),
              name: custom_value.name,
              value:
                (typeof custom_value.value == "object"
                  ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                  : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))+this.getSuffixValue(custom_value.suffix),
            });
          } else {
            this.customValues.push({
              id: custom_value.cv_id,
              fieldKey: custom_value.fieldKey,
              field_type: this.custom_value_type(custom_value.custom_field_type_id),
              name: custom_value.name,
              value: this.getPrefixValue(custom_value.prefix)+this.getOperationValue(operation)+this.getSuffixValue(custom_value.suffix),
            });
          }
        }
      );

      if (this.formnumber == this.pages.length - 1) {
        let customs = [];
        this.pages.forEach((page) => {
          customs.push(...Object.values(page.custom_values));
        });

        this.operations.forEach((operation) => {
          const result = customs.find(
            ({ fieldKey }) => fieldKey === operation.result
          );

          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              fieldKey: operation.result,
              field_type: '',
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }

        });


        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber, true);
        return false;
      }

      if (change) {
        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, change);
      } else {
        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, false);
      }
    },

    save(change) {
      if (!this.validateform()) {
        return false;
      }
      this.contentChange(change);
    },

    nextPrev(n) {
      // Handle Previous button
      if (n === -1 && this.currentTab > 0) {
        this.currentTab = this.currentTab - 1;
        // this.showTab(this.currentTab);
        return;
      }
      
      // Handle Next button
      if (n === 1) {
        // Exit if any field in the current tab is invalid:
        if (!this.validateForm()) return false;
        
        // Check if we're on the last tab
        if (this.currentTab >= this.pages.length - 1) {
          // Handle final submission
          this.customValues = [];
          
          // Collect all values for final submission
          this.pages.forEach((page) => {
            Object.values(page.custom_values).forEach((custom_value) => {
              const operation = this.operations.find(
                ({ result }) => result === custom_value.fieldKey
              );

              if (operation == null) {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value:
                  this.getPrefixValue(custom_value.prefix)+
                    (typeof custom_value.value == "object"
                      ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                      : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))+this.getSuffixValue(custom_value.suffix),
                });
              } else {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value: this.getPrefixValue(custom_value.prefix)+this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, this.getOperationValue(operation))+this.getSuffixValue(custom_value.suffix),
                });
              }
            });
          });

          // Add operation results
          this.operations.forEach((operation) => {
            const customs = [];
            this.pages.forEach((page) => {
              customs.push(...Object.values(page.custom_values));
            });
            
            const result = customs.find(
              ({ fieldKey }) => fieldKey === operation.result
            );

            if (result == null) {
              this.customValues.push({
                id: this.getOperationId(operation.result),
                fieldKey: operation.result,
                field_type: '',
                name: this.getOperationName(operation.result),
                value: this.getOperationValue(operation),
              });
            }
          });
          
          this.$emit("save", this.action, this.customValues, this.currentTab, n, true);
          return false;
        } else {
          // Collect current tab values only
          if (this.currentTab == 0) this.customValues = [];
          
          Object.values(this.pages[this.currentTab].custom_values).forEach(
            (custom_value) => {
              const operation = this.operations.find(
                ({ result }) => result === custom_value.fieldKey
              );

              if (operation == null) {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value:
                  this.getPrefixValue(custom_value.prefix)+
                    (typeof custom_value.value == "object"
                      ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                      : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))+this.getSuffixValue(custom_value.suffix),
                });
              } else {
                this.customValues.push({
                  id: custom_value.cv_id,
                  fieldKey: custom_value.fieldKey,
                  field_type: this.custom_value_type(custom_value.custom_field_type_id),
                  name: custom_value.name,
                  value: this.getPrefixValue(custom_value.prefix)+this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, this.getOperationValue(operation))+this.getSuffixValue(custom_value.suffix),
                });
              }
            }
          );
          
          // Save current tab and move to next
          const previousTab = this.currentTab;
          
          // Emit save event with current tab data
          this.$emit("save", this.action, this.customValues, previousTab, this.currentTab, false);
          return false;
        }
      }
    },

    validateForm() {
      // This deals with validation of the form fields
      var x,
        y,
        i,
        valid = true;
      x = document.getElementsByClassName("tab");
      y = x[this.currentTab].getElementsByClassName("required");

      // A loop that checks every input field in the current tab:
      for (i = 0; i < y.length; i++) {
        // If a field is empty...
        if (y[i].value == "") {
          // add an "invalid" class to the field:
          y[i].classList.add("invalid");
          // and set the current valid status to false:
          valid = false;
        }
      }

      // If the valid status is true, mark the step as finished and valid:
      if (valid) {
        document.getElementsByClassName("step")[this.currentTab].className +=
          " finish";
      }
      return valid; // return the valid status
    },

    onNext() {
      this.formnumber++;
      this.updateform();
      this.progress_forward();
    },
    onBack() {
      this.formnumber--;
      this.updateform();
      this.progress_backward();
    },
    updateform() {
      // this.main_form.forEach(function (mainform_number) {
      //   mainform_number.classList.remove("active");
      //   mainform_number.classList.remove("slideDown");
      // });
      // this.main_form[this.formnumber].classList.add("slideDown");
      // this.main_form[this.formnumber].classList.add("active");
    },
    progress_forward() {
      this.num.innerHTML = this.formnumber + 1;
      this.step_list[this.formnumber].classList.add("active");
    },
    progress_backward() {
      var form_num = this.formnumber + 1;
      this.step_list[form_num].classList.remove("active");
      this.num.innerHTML = form_num;
    },
    validateform() {
      let validate = true;
      this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active select"), ...document.querySelectorAll(".main.active textarea")];
      this.validate_inputs.forEach(function (vaildate_input) {
        vaildate_input.classList?.remove("warning");
        if (vaildate_input.classList.value?.includes("require")) {
          if (vaildate_input.value.length == 0) {
            validate = false;
            vaildate_input.classList?.add("warning");
          }
        }
      });
      return validate;
    },


    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    saveFile(file, custom) {

      this.filePreloader = true
      let data = new FormData();
      data.append("file", file);
      data.append("custom_id", custom.id);
      coreLibrary.methods.axiosPost({
        url: "/file/upload",
        data,
      }).then(({ data }) => {
        custom.value = data
        custom.hhh = data
      })
        .catch(({ response }) => {
          if (response.data && response.data.message) {
            this.$toastr.e(response.data.message);
            const errors = Object.values(response.data.data).map((el) => el[0]);
            this.$toastr.e(errors);
          }
        })
        .finally(() => {
          this.filePreloader = false

        });
    },

    reoderCustomValues(customValues) { },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },

    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = this.removePrefixSuffixValue(custom.prefix, custom.suffix, value);
      }
    },

    getFieldOperationValue(operand1, operand2, operator, type) {
      let op2;
      let op1;

      var operand1_without_space = operand1.replace(/\s+/g, "");
      var operand2_without_space = operand2.replace(/\s+/g, "");

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } 
      else if (this.field_index[operand1_without_space] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1_without_space]][
            this.field_index[operand1_without_space]
          ].value;
      }
      else {
        op1 = this.findOperationValue(operand1);
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } 
      else if (this.field_index[operand2_without_space] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2_without_space]][
            this.field_index[operand2_without_space]
          ].value;
      } 
      else {
        op2 = this.findOperationValue(operand2);
      }

      return this.makeOperation(type, operator, op1, op2);
    },

    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseFloat(op1);
        op2 = parseFloat(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },

    next(tab, n) {
      this.currentTab = n + 1
      this.showTab(this.currentTab);
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },

    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },

    findOperationValue(op) {
      if (this.field_index[op] !== undefined) {
        let op1 =
          this.field_values[this.page_index[op]][
            this.field_index[op]
          ].value;
          return op1;
      }

      let value;
      const result = Object.values(this.pages[this.formnumber].custom_values).find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value??'';
        }
      } else {
        value = result.value??'';
      }
      return value;
    },

    showTooltip(event, fieldKey) {
      clearTimeout(this.tooltipTimeout);
      this.activeTooltipId = fieldKey;
    },

    hideTooltip() {
      this.tooltipTimeout = setTimeout(() => {
        this.activeTooltipId = null;
      }, 100);
    },

    toggleTooltip(event, fieldKey) {
      event.stopPropagation();
      
      if (this.activeTooltipId === fieldKey) {
        this.activeTooltipId = null;
      } else {
        clearTimeout(this.tooltipTimeout);
        this.activeTooltipId = fieldKey;
      }
    },
    
    handleClickOutside(event) {
      if (!event.target.closest('.tooltip-button')) {
        this.activeTooltipId = null;
      }
    },
    
    isTooltipActive(fieldKey) {
      return this.activeTooltipId === fieldKey;
    },

  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  background-color: transparent !important;
  min-height: 42px !important;
  padding: 12px 40px 0 5px !important;
  outline: 0 !important;
  border: 1px solid #d4dfe4 !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background-color: blue !important;
  color: white !important;
}

.multiselect__select {
  padding: 30px 8px;
}
</style>
